module.exports = __webpack_public_path__ + "static/media/Scuff_Before.a7a3e3ea.jpg";